import {Modal} from 'react-bootstrap';
import styled from 'styled-components';

export  const StyledModal = styled(Modal)`
        .modal-body textarea{
             color: ${props => props.theme.textColor};
             border: 1px solid ${props => props.theme.borderColor};
        }
        .modal-body textarea:focus{
             box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(${props => props.theme.boxShadowRGBA});
        }
        .modal-body input{
             color: ${props => props.theme.textColor};
             border: 1px solid ${props => props.theme.borderColor};
        }
        .modal-body input:focus{
             box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(${props => props.theme.boxShadowRGBA});
        }
        .modal-title{
             color: ${props => props.theme.brandColor};
        }
        .modal-header{
             border-bottom-color: ${props => props.theme.borderColor};
        }
        .modal-footer{
             border-top-color: ${props => props.theme.borderColor};
        }
        z-index:1050;
`;



// WEBPACK FOOTER //
// ./components/utils/Styled/modal.js